import React from 'react';
import PropTypes from 'prop-types';
import ThemeProvider from 'zignal-landscape/lib/ThemeProvider';
import Heading from 'zignal-landscape/lib/Heading';
import { Light } from 'themes';

// The admin screens' title row from the Backbone edit-user template: back link, then the page title.
const AdminHeader = ({ title, onBack }) => (
  <ThemeProvider theme={Light}>
    <div>
      <a
        className="back-to-users"
        href="/settings/users/"
        data-cy="user-form-back"
        onClick={(e) => { e.preventDefault(); onBack(); }}
      >
        <i className="icon-arrow-left" /> Back to Users
      </a>
      <div data-cy="user-form-heading"><Heading>{title}</Heading></div>
    </div>
  </ThemeProvider>
);

AdminHeader.propTypes = { title: PropTypes.string.isRequired, onBack: PropTypes.func.isRequired };

export default AdminHeader;
